import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  ConnectWithHubspot,
  IntegrationBenefits,
  Uninstall,
} from "./components";
import { SiHubspot } from "react-icons/si";
import { v4 as uuidv4 } from "uuid";
import {
  ClassNames,
  getCookie,
  // getDataFromDb,
  // updateDataInDb,
} from "../../../../helper";
import { FaAngleLeft } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { getDataFromMongoDb, updateDataInMongoDb } from "../../../../services/mongod.data";
const CF_Hubspot_API_URL =
  "https://us-central1-causalfunnel-21.cloudfunctions.net/CF_Hubspot_server";

const Hubspot = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const hubspotAuthCode = queryParams.get("code");
  const [install, setInstall] = useState(false);
  const [integration, setIntegration] = useState(false);
  const [integrationData, setIntegrationData] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authName, setAuthName] = useState("");

  const [accessToken, setAccessToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [lists, setLists] = useState([]);
  const [listId, setListId] = useState("");

  const [page, setPage] = useState(1);

  const installHandler = (state) => setInstall(state);

  useEffect(() => {
    if (!integration) setIntegrationData({});
  }, [integration]);

  useEffect(() => {
    setAuthName(`${uuidv4()} HubSpot account`);
  }, []);

  useEffect(() => {
    if (!hubspotAuthCode && !refreshToken) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        let postData = {};
        if (refreshToken) {
          postData = {
            refreshToken: refreshToken,
          };
        } else {
          postData = {
            code: hubspotAuthCode,
          };
        }

        const response = await axios.post(CF_Hubspot_API_URL, postData);
        const { access_token, refresh_token, lists } = response.data;

        if (access_token) {
          setAccessToken(access_token);
          setRefreshToken(refresh_token);
          setLists(lists);

          let api_url = `${user}/graph-integration/hubspot`;
          let result = await updateDataInMongoDb(user, "graph-integration", ["hubspot" ], {
            access_token: access_token,
            refresh_token: refresh_token,
          });

          setIntegration(true);
          if (hubspotAuthCode) {
            setInstall(true);
            navigate({ replace: true, search: "" });
          }
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [hubspotAuthCode, refreshToken]);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      setLoading(true);
      try {
        // let api_url = `${user}/graph-integration/hubspot`;
        // let result = await getDataFromDb(api_url);
        let apiData = await getDataFromMongoDb(user, "graph-integration");
        let result = apiData.data.hubspot || apiData.data.data.hubspot;

        if (result && result?.access_token) {
          setIntegration(true);
          setAuthName(result?.authName);
          setAccessToken(result?.access_token);
          setRefreshToken(result?.refresh_token);
          setListId(result?.listId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user]);

  return (
    <div className="bg-gray-200 w-full p-3 relative">
      <NavLink
        to="/integration"
        className="text-indigo-600 text-lg text-semibold flex gap-1 items-center "
      >
        <FaAngleLeft className="text-sm" />
        Go back
      </NavLink>
      <div className="bg-white  p-4 rounded-md my-3">
        <header className="flex justify-between items-center border-bottom">
          <div className="my-3 flex items-center gap-3">
            <SiHubspot className="text-3xl text-gray-500" />
            <p className="text-lg font-semibold">HubSpot</p>
          </div>
          {integration && !install ? (
            <div className="space-x-2">
              <button
                className={ClassNames(
                  "text-gray-700 border p-1.5 rounded-md px-3.5 hover:cursor-pointer hover:bg-gray-100"
                )}
                onClick={() => setOpen(true)}
              >
                Uninstall
              </button>
              <button
                className={ClassNames(
                  "text-indigo-700 bg-indigo-200 p-1.5 rounded-md px-3.5 hover:bg-indigo-300 hover:cursor-pointer"
                )}
                onClick={() => setInstall(true)}
              >
                Configure
              </button>
            </div>
          ) : (
            <button
              className={ClassNames(
                "text-white bg-indigo-600 p-1.5 rounded-md px-3.5 hover:bg-indigo-500 hover:cursor-pointer",
                install ? "hidden" : ""
              )}
              onClick={() => setInstall(true)}
            >
              Install HubSpot
            </button>
          )}
        </header>
        {install ? (
          <ConnectWithHubspot
            installHandler={installHandler}
            integration={integration}
            authName={authName}
            setAuthName={setAuthName}
            page={page}
            setPage={setPage}
            lists={lists}
            listId={listId}
            setListId={setListId}
          />
        ) : (
          <div className="relative">
            <Uninstall
              open={open}
              setOpen={setOpen}
              setIntegration={setIntegration}
            />
            <IntegrationBenefits />
          </div>
        )}
      </div>
    </div>
  );
};

export default Hubspot;
